module.exports = __webpack_public_path__ + "img/title-1.c65d73b5.png";